import moment from 'moment';

export const formatDateTimeForString = (stringDate: string): string => {
    return moment(stringDate).format('DD.MM.YYYY HH:mm');
};

/**
 * Получает диапазон дат для фильтров по умолчанию (по дням)
 */
export const getDateRange = (countBack: number, backParameter: 'days'): {
    startDate: string;
    endDate: string;
} => {
    return {
        startDate: moment().subtract(countBack, backParameter).format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD')
    };
};

export const getCurrentDateTime = () => moment().format('YYYY-MM-DDTHH:mm');
